// Inspecteur · Externe partijen — the full tenant external-party directory (controllers/processors/
// recipients/JCs/contacts). P2/Phase D: now the shadcn PartyRegister (was inline-style AggregateCrud) with
// no kind filter = the whole directory. RLS-scoped; gated partner_relationship.
import { PartyRegister } from "./party-views";

export function ExternalPartiesRoute() {
  return <PartyRegister titleKey="ins.parties.title" />;
}
